<template>
  <div class="mb-3">
    <Component :is="h2 ? 'h2' : 'h1'" :class="{
      'h4': !h2,
      'h5': h2,
      'heading-badge': targetPlan
    }">
      <span>{{title}}</span>
      <UpgradeBadge :targetPlan="targetPlan" :noFreeUsers="noFreeUsers" :tryForFree="tryForFree" class="ml-2" v-if="targetPlan" />
    </Component>
    <p class="font-weight-normal mb-0" v-if="subTitle">{{subTitle}}</p>
  </div>
</template>

<script>
import UpgradeBadge from '@/components/UpgradeBadge'

export default {
  components: {
    UpgradeBadge
  },
  props: {
    title: String,
    subTitle: String,
    h2: Boolean,

    targetPlan: String,
    tryForFree: Boolean,
    noFreeUsers: Boolean
  }
}
</script>
